// extracted by mini-css-extract-plugin
export default {"label":"lBHPoUGLIJttrmlJDstM"};